import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey) 

// Types pour TypeScript
export interface Database {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          email: string
          name: string
          phone?: string
          address?: string
          linkedin?: string
          website?: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id: string
          email: string
          name: string
          phone?: string
          address?: string
          linkedin?: string
          website?: string
        }
        Update: {
          email?: string
          name?: string
          phone?: string
          address?: string
          linkedin?: string
          website?: string
          updated_at?: string
        }
      }
      cvs: {
        Row: {
          id: string
          user_id: string
          filename: string
          content: string
          file_size: number
          file_type: string
          created_at: string
          updated_at: string
        }
        Insert: {
          user_id: string
          filename: string
          content: string
          file_size: number
          file_type: string
        }
        Update: {
          filename?: string
          content?: string
          file_size?: number
          file_type?: string
          updated_at?: string
        }
      }
      analyses: {
        Row: {
          id: string
          user_id: string
          cv_id?: string
          job_title: string
          job_company: string
          job_description: string
          global_score: number
          results: any
          created_at: string
        }
        Insert: {
          user_id: string
          cv_id?: string
          job_title: string
          job_company: string
          job_description: string
          global_score: number
          results: any
        }
        Update: {
          job_title?: string
          job_company?: string
          job_description?: string
          global_score?: number
          results?: any
        }
      }
      subscriptions: {
        Row: {
          id: string
          user_id: string
          plan: string
          analyses_used: number
          analyses_remaining: number
          is_active: boolean
          created_at: string
          updated_at: string
          expires_at: string
          stripe_subscription_id: string
        }
        Insert: {
          user_id: string
          plan: string
          analyses_used?: number
          analyses_remaining: number
          is_active?: boolean
          expires_at?: string
          stripe_subscription_id?: string
        }
        Update: {
          plan?: string
          analyses_used?: number
          analyses_remaining?: number
          is_active?: boolean
          updated_at?: string
          expires_at?: string
          stripe_subscription_id?: string
        }
      }
    }
  }
}